import React from 'react';
import {Field} from 'react-final-form';
import block from 'bem-cn-lite';

import {FormFieldNumberInput} from 'components/formFields';
import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import FieldBottomLabel from 'components/calculator/FieldBottomLabel/FieldBottomLabel';

const b = block('MDBForm');

interface HostsInputProps {
    name: string;
    nameKey?: string;
    hostsRange: {
        minHosts: number;
        maxHosts: number;
    };
    handleChange: (value: number) => void;
    title: string;
    note: string;
    labels: string[];
}

const HostsInput: React.FC<HostsInputProps> = (props) => {
    const {
        name,
        nameKey,
        title,
        note,
        handleChange,
        hostsRange: {minHosts, maxHosts},
        labels,
    } = props;

    return (
        <CalculatorFormLayout.Row title={title} note={note}>
            <Field name={`${name}.${nameKey || 'hosts'}`}>
                {(fieldProps) => (
                    <FormFieldNumberInput
                        {...fieldProps}
                        onUpdate={handleChange}
                        component={FormFieldNumberInput}
                        step={1}
                        className={b('hosts')}
                        range={{
                            min: minHosts,
                            max: maxHosts,
                        }}
                        readOnly
                    />
                )}
            </Field>
            {labels.map((label) => (
                <FieldBottomLabel key={label}>{label}</FieldBottomLabel>
            ))}
        </CalculatorFormLayout.Row>
    );
};

export default HostsInput;
